import {
    FacebookFilled,
    TwitterSquareFilled,
    LinkedinFilled,
    LinkOutlined,
} from "@ant-design/icons";
import styles from './index.module.scss'

export const ShareArticleButtons = ({ title }) => {
    const pageUrl = encodeURIComponent(window.location.href)
    const pageTitle = encodeURIComponent(title);

    const shareLinks = {
        facebook: `https://www.facebook.com/sharer/sharer.php?u=${pageUrl}`,
        twitter: `https://twitter.com/intent/tweet?url=${pageUrl}&text=${pageTitle}`,
        linkedin: `https://www.linkedin.com/shareArticle?mini=true&url=${pageUrl}&title=${pageTitle}`,
    };

    const openShare = (url) => {
        window.open(url, "_blank", "width=600,height=400,noopener,noreferrer");
    };

    const copyLink = async () => {
        try {
            await navigator.clipboard.writeText(window.location.href);
            alert("Link copied to clipboard!");
        } catch {
            alert("Failed to copy link.");
        }
    };

    return <div className={styles.share}>
        <h4>Share This News</h4>
        <div className={styles.icons}>
            <FacebookFilled onClick={() => openShare(shareLinks.facebook)} style={{ cursor: "pointer" }} />
            <TwitterSquareFilled onClick={() => openShare(shareLinks.twitter)} style={{ cursor: "pointer" }} />
            <LinkedinFilled onClick={() => openShare(shareLinks.linkedin)} style={{ cursor: "pointer" }} />
            <LinkOutlined onClick={copyLink} style={{ cursor: "pointer" }} />
        </div>
    </div>
}